window.imoveisVisiveis = {};

window.setimoveisVisiveis = json => {
	if(imoveisVisiveis){
		imoveisVisiveis = json;
	}
};

window.ajaxAsync = async (url, data) => {
	
	var result = [];
	for(var i in data){
		result.push(encodeURIComponent(i) + '=' + encodeURIComponent(data[i]));
	}

	try {

		return fetch(url, {
			method: 'POST',
			mode: 'cors',
			headers: {
				'Content-Type':'application/x-www-form-urlencoded'
			},
			body: result.join('&')
		}).then(async resposta => {
			if(!resposta.ok){
				throw new Error('http-error');
			}

			return resposta.json();

		}).catch (error => {
				console.error(error)
				throw error;
			}
		);

	} catch (erro) {
		console.error('ERROW: ' + erro);
	}
};

/* Função responsável por alterar a imagem da miniatura do imóvel quando é clicado nos botões left ou right */
window.miniaturaChangeImg = function(miniatura_id, acao = 1){

	var imagemPrincipal = Boss.getById(miniatura_id);
	var imo_codigo = miniatura_id.split('-')[1];
	var btnleft = Boss.getById('btnleft-' + imo_codigo);
	var btnright = Boss.getById('btnright-' + imo_codigo);

	if(imagemPrincipal){
		var current = imoveisimagens[imo_codigo][0];
		var atual = imagemPrincipal.getAttribute('data-imgatual');

		var novaImagem = current;
		var nImagem = 0;

		/* acao = 1 === DIREITA */
		if(acao == 1){

			var maior = (Number(atual) + 1);

			if(imoveisimagens[imo_codigo][maior]){

				if((Number(imoveisimagens[imo_codigo].length) - 1) == maior){
					novaImagem = imoveisimagens[imo_codigo][maior];
					nImagem = maior;

					btnright.classList.add('hidden');
					btnleft.classList.remove('hidden');

					return false;
				}else{

					btnright.classList.remove('hidden');
					btnleft.classList.remove('hidden');
				}

				novaImagem = imoveisimagens[imo_codigo][maior];
				nImagem = maior;
			}

		}else{
		/* acao = 0 === ESQUERDA */

			var menor = (Number(atual) > 0 ? Number(atual) - 1 : 0);
		
			if(imoveisimagens[imo_codigo][menor]){
				novaImagem = imoveisimagens[imo_codigo][menor];
				nImagem = menor;

				btnright.classList.remove('hidden');
				btnleft.classList.remove('hidden');
			}

			if(menor == 0){
				btnright.classList.remove('hidden');
				btnleft.classList.add('hidden');
			}
		}

		/* Altera a data-imgatual Da IMAGEM e o SRC da mesma */
		imagemPrincipal.setAttribute('data-imgatual', nImagem);
		imagemPrincipal.src = jsdominioimg + '/imoveis/thumb/' + novaImagem;
	}
};

/* Recupera todas as imagens dos imóveis disponíveis */
window.getImovelImagens = e => {

	Boss.ajax({
		'url': '/imoveis/getImovelImagens',
		'data': {
			'getimagens': 'getimagens',
			'imoveisVisiveis': JSON.stringify(imoveisVisiveis)
		},
		'dataType': 'json',
		'done': rtn => {

			if(rtn.r == 'ok'){
				imoveisimagens = rtn.info;

				/* PRELOADER */
				for(var x in rtn.info){

					for(var y in rtn.info[x]){

						var img = document.createElement('img');
						img.src = jsdominioimg+'/imoveis/thumb/'+rtn.info[x][y];
					}
				}
			}
		},
		error: rtn => {
			Boss.warning({message: 'Falha ao enviar, tente novamente em alguns segundos!'});
		}
	});
}

window.share = function(rede, link){

	let url = 'mobile';
	if(Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > 1100){
		url = 'pc';
	}

	if(rede == 'facebook'){

		if(url == 'mobile'){

			window.open("https://www.facebook.com/share.php?u="+link, '_blank');
		}else{

			window.open("https://www.facebook.com/share.php?u="+link, '_blank', 'width=800, height=600, toolbar=no, top=50, left=50');
		}
	}	

	if(rede == 'whatsapp'){

		if(url == 'mobile'){

			window.open("whatsapp://send?text="+link, '_blank');
		}else{

			window.open("https://web.whatsapp.com/send?text="+link, '_blank');
		}
	}

	if(rede == 'twitter'){

		if(url == 'mobile'){

			window.open("https://twitter.com/home?status="+link, '_blank');
		}else{
			window.open("https://twitter.com/home?status="+link, '_blank', 'width=800, height=600, toolbar=no, top=50, left=50');
		}
	}
};

window.imovelImprimirTipo = imo_codigo => {

	var pathurl = `${jsdominio}/imoveis/imprimir/?id=${imo_codigo}`;
	window.open(pathurl);
}

/* PC */
window.toggleMenu = function(){

var nav = Boss.getById('nav-menu');

/* Se houver o elemento NAV, check de o menu está fechado e ABRE, se tiver aberto FECHA */
nav ? nav.classList.contains('nav_open') ? closeMenu() : openMenu() : false;
};

window.openMenu = function(){

var nav = Boss.getById('nav-menu');

/* PARA VERSÃO PC */
if(nav){
	nav.classList.add('nav_open');
	nav.classList.remove('nav_close');

	document.querySelector('.img-btn-menu') ? document.querySelector('.img-btn-menu').setAttribute('class', 'img-btn-menu icl ic-times') : false;
}
};

window.closeMenu = function(){
var nav = Boss.getById('nav-menu');

if(nav && nav.classList.contains('nav_open') === true){
	nav.classList.add('nav_close');
	nav.classList.remove('nav_open');
	document.querySelector('.img-btn-menu') ? document.querySelector('.img-btn-menu').setAttribute('class', 'img-btn-menu icl ic-bars') : false;
}
};

window.imovelImprimir = imo_codigo => {

	if(typeof(imo_codigo) == 'undefined'){
		return false;
	}

	let html = `
		<div class="boss-dialog-area">
			<h1>Imprimir Imóvel ID: ${imo_codigo}</h1>
			<p>Escolha o tipo para impressão.</p>
			<div class="site-space-1"></div>
			<div class="block width-50">
				<button name="button"  class="b b-padrao width-100" onclick="imovelImprimirTipo(${imo_codigo});"><i class="icl ic-file-image"></i> Retrato Simples</button>
			</div><div class="block width-50">
				<button name="button"  class="b b-padrao width-100" onclick="imovelImprimirTipo(${imo_codigo});"><i class="icl ic-file-image"></i> Retrato Completa</button>
			</div><div class="block width-50 align-middle">
				<button name="button"  class="b b-padrao width-100" onclick="imovelImprimirTipo(${imo_codigo});"><i class="icl ic-image"></i> Paisagem Simples</button>
			</div><div class="block width-50 align-middle">
				<button name="button"  class="b b-padrao width-100" onclick="imovelImprimirTipo(${imo_codigo});"><i class="icl ic-image"></i> Paisagem Completa</button>
			</div>
			<div class="site-space-1"></div>
		</div>
	`;

	Boss.dialog.open({
		'invisible': false,
		'close': true,
		'html': html
	});
}

Boss.evts.add('scroll', document, evts => {

	if(window.scrollY > (document.documentElement.clientHeight || 0)){
		document.querySelector('.b-tohome') ? document.querySelector('.b-tohome').classList.remove('hidden') : null;
	}else{
		document.querySelector('.b-tohome') ? document.querySelector('.b-tohome').classList.add('hidden') : null;
	}
});



!(function (window) {
	var $q = function (q, res) {
		if (document.querySelectorAll) {
			res = document.querySelectorAll(q);
		} else {
			var d = document,
				a = d.styleSheets[0] || d.createStyleSheet();
			a.addRule(q, "f:b");
			for (var l = d.all, b = 0, c = [], f = l.length; b < f; b++) l[b].currentStyle.f && c.push(l[b]);
			a.removeRule(0);
			res = c;
		}
		return res;
	},
	addEventListener = function (evt, fn) {
		window.addEventListener ? this.addEventListener(evt, fn, true) : window.attachEvent ? this.attachEvent("on" + evt, fn) : (this["on" + evt] = fn);
	},
	_has = function (obj, key) {
		return Object.prototype.hasOwnProperty.call(obj, key);
	};
function loadImage(el, fn) {
	var img = new Image(),
		src = el.getAttribute("data-src");
		img.onload = function () {
			if (!!el.parent) {
				el.parent.replaceChild(img, el);
			} else {
				el.src = src;
			}
			if (fn) {
				fn();
			}
		};
	img.src = src;
}
function elementInViewport(el) {
	var rect = el.getBoundingClientRect();
	return rect.top >= 0 && rect.left >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);
}
window.images_site = new Array(),
	query = $q("img.lazy"),
	processScroll = function () {
		
		for (var i = 0; i < images_site.length; i++) {
			if (elementInViewport(images_site[i])) {
				loadImage(images_site[i], function () {
					images_site.splice(i, i);
				});
			}
		}
	};
for (var i = 0; i < query.length; i++) {
	images_site.push(query[i]);
}
processScroll();
addEventListener("scroll", processScroll);
})(this);


/* CARREGA APENAS IMAGENS */
window.loadingLazy = {
	images: new Array(),
	selectorAll: "img.lazy",
	query: document.querySelectorAll(this.selectorAll),
	loadImage: (el, fn) => {

		var img = new Image();
		if(el.getAttribute("data-src")){
			var	src = el.getAttribute("data-src");
			img.onload = f => {
				el.src = src;
				if(fn){
					fn();
				}
				el.classList.remove('lazy');
				el.removeAttribute('data-src');
			};
			img.src = src;
			img.removeAttribute('data-src');
			img.classList.remove('lazy');
		}
			
	},
	elementInViewport: (el) => {
		var top = el.offsetTop;
		var left = el.offsetLeft;
		var width = el.offsetWidth;
		var height = el.offsetHeight;
		
		while(el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}
		
		return (
			top < (window.pageYOffset + window.innerHeight) &&
			left < (window.pageXOffset + window.innerWidth) &&
			(top + height) > window.pageYOffset &&
			(left + width) > window.pageXOffset
		);
	},
	processScroll: f => {

		/* Verifica se já foi mostrado todas as img / bg */
		/* console.log(document.body.querySelectorAll('.lazy')); */
		if(document.body.querySelectorAll('.lazy').length <= 0){
			/* console.log('PRONTO, JA CARREGOU TUDO AS IMG!'); */
			//window.removeEventListener("scroll", loadingLazy.processScroll, true);
		};

		for (var i = 0; i < loadingLazy.images.length; i++) {
			
			if (loadingLazy.elementInViewport(loadingLazy.images[i])) {
				
				loadingLazy.loadImage(loadingLazy.images[i], () => {
					loadingLazy.images.splice(i, i);
				});
			}
		}
	},
	consultaImagens: elemento_escuta => {
		loadingLazy.query = elemento_escuta.querySelectorAll(loadingLazy.selectorAll);

		for (var i = 0; i < loadingLazy.query.length; i++) {
			loadingLazy.images.push(loadingLazy.query[i]);
		}
	},
	listener: f => {
		window.addEventListener("scroll", loadingLazy.processScroll, true);
	},
	push: elemento_escuta => {
		window.removeEventListener("scroll", loadingLazy.processScroll, true);
		loadingLazy.images = new Array();
		loadingLazy.consultaImagens(elemento_escuta);
		loadingLazy.processScroll();
		loadingLazy.listener();
	},
	init: elemento_escuta => {
		loadingLazy.consultaImagens(elemento_escuta);
		loadingLazy.processScroll();
		loadingLazy.listener();
	}
};

/* CARREGA APENAS BACKGROUNDS */
window.loadingLazyBG = {
	images: new Array(),
	selectorAllBg: "div.lazybg",
	queryBg: document.querySelectorAll(this.selectorAllBg),
	elementInViewport: (el) => {
		var top = el.offsetTop;
		var left = el.offsetLeft;
		var width = el.offsetWidth;
		var height = el.offsetHeight;
		
		while(el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}
		
		return (
			top < (window.pageYOffset + window.innerHeight) &&
			left < (window.pageXOffset + window.innerWidth) &&
			(top + height) > window.pageYOffset &&
			(left + width) > window.pageXOffset
		);
	},
	processScroll: f => {

		if(typeof(puta) !== undefined){
			//console.log('working BG..');

			/* Verifica se já foi mostrado todas as img / bg */
			if(document.body.querySelectorAll('.lazybg').length <= 0){
				// console.log('PRONTO, JA CARREGOU TUDO OS BG!');
				window.removeEventListener("scroll", loadingLazyBG.processScroll, true);
			};

			for (var j = 0; j < loadingLazyBG.queryBg.length; j++) {
				if (loadingLazyBG.elementInViewport(loadingLazyBG.queryBg[j])) {
					var imgtype = loadingLazyBG.queryBg[j].getAttribute('data-type');
					var doubleimg = loadingLazyBG.queryBg[j].getAttribute('data-fodace') ? loadingLazyBG.queryBg[j].getAttribute('data-fodace') : '';
					puta(`
						if(typeof(${loadingLazyBG.queryBg[j].id}) !== 'undefined'){
							dev.background(${loadingLazyBG.queryBg[j].id},'${imgtype}','${doubleimg}');
							flagzinha = false; 
						}
					`);
					loadingLazyBG.queryBg[j].classList.remove('lazybg');
				}
			}
		}
	},
	push: elemento_escuta => {

		loadingLazyBG.queryBg = elemento_escuta.querySelectorAll(loadingLazyBG.selectorAllBg);

		loadingLazyBG.processScroll();
	},
	init: elemento_escuta => {

		window.removeEventListener("scroll", loadingLazyBG.processScroll, true);
		loadingLazyBG.push(elemento_escuta);
		window.addEventListener("scroll", loadingLazyBG.processScroll, true);
	}
};

loadingLazy.init(document.body);
loadingLazyBG.init(document.body);

window.initLeadEntranceModal = () => {

	var storageKey = 'redeville_lead_modal_status';
	var storageLeadKey = 'redeville_lead_modal_data';

	if(!document.body || document.getElementById('lead-entrance-modal')){
		return false;
	}

	try{
		if(window.localStorage && localStorage.getItem(storageKey)){
			return false;
		}
	}catch(error){
		console.error(error);
	}

	var modalWrapper = document.createElement('div');
	modalWrapper.id = 'lead-entrance-modal';
	modalWrapper.className = 'lead-entrance-modal';
	modalWrapper.setAttribute('aria-hidden', 'true');

	modalWrapper.innerHTML = `
		<div class="lead-entrance-modal__overlay" data-lead-close="overlay"></div>
		<div class="lead-entrance-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="lead-entrance-title">
			<button type="button" class="lead-entrance-modal__close" aria-label="Fechar formul\u00e1rio" data-lead-close="button">
				<span>&times;</span>
			</button>
			<div class="lead-entrance-modal__content">
				<div class="lead-entrance-modal__text">
					<p class="lead-entrance-modal__eyebrow">Atendimento r\u00e1pido</p>
					<h2 id="lead-entrance-title">Quer que nossa equipe entre em contato?</h2>
					<p class="lead-entrance-modal__description">Deixe seus dados para receber um atendimento mais r\u00e1pido e personalizado logo no in\u00edcio da navega\u00e7\u00e3o.</p>
					<ul class="lead-entrance-modal__benefits">
						<li>Nome completo para identifica\u00e7\u00e3o</li>
						<li>E-mail para envio de informa\u00e7\u00f5es</li>
						<li>Telefone para contato direto</li>
					</ul>
				</div>
				<form class="lead-entrance-modal__form" id="lead-entrance-form">
					<label for="lead-entrance-name">Nome</label>
					<input id="lead-entrance-name" name="nome" type="text" placeholder="Como podemos te chamar?" maxlength="120" required>

					<label for="lead-entrance-email">E-mail</label>
					<input id="lead-entrance-email" name="email" type="email" placeholder="voce@exemplo.com" maxlength="120" required>

					<label for="lead-entrance-phone">Telefone</label>
					<input id="lead-entrance-phone" name="telefone" type="tel" placeholder="(00) 00000-0000" maxlength="16" required>

					<label class="lead-entrance-modal__check">
						<input id="lead-entrance-privacy" name="politica" type="checkbox" required>
						<span>Concordo com a <a href="/politica" target="_blank" rel="noopener noreferrer">Pol\u00edtica de Privacidade</a> e com o contato para atendimento da minha solicita\u00e7\u00e3o.</span>
					</label>

					<p class="lead-entrance-modal__feedback" id="lead-entrance-feedback" aria-live="polite"></p>

					<div class="lead-entrance-modal__actions">
						<button type="submit" class="lead-entrance-modal__submit">Quero atendimento</button>
						<button type="button" class="lead-entrance-modal__skip" data-lead-close="skip">Continuar sem preencher</button>
					</div>
				</form>
			</div>
		</div>
	`;

	var closeModal = status => {
		modalWrapper.classList.remove('is-visible');
		modalWrapper.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('lead-entrance-modal-open');

		try{
			if(window.localStorage && status){
				localStorage.setItem(storageKey, status);
			}
		}catch(error){
			console.error(error);
		}
	};

	var openModal = () => {
		modalWrapper.classList.add('is-visible');
		modalWrapper.setAttribute('aria-hidden', 'false');
		document.body.classList.add('lead-entrance-modal-open');
	};

	var phoneInput = modalWrapper.querySelector('#lead-entrance-phone');
	var form = modalWrapper.querySelector('#lead-entrance-form');
	var feedback = modalWrapper.querySelector('#lead-entrance-feedback');
	var submitButton = modalWrapper.querySelector('.lead-entrance-modal__submit');

	phoneInput.addEventListener('input', event => {
		var numbers = event.target.value.replace(/\D/g, '').slice(0, 11);

		if(numbers.length <= 10){
			numbers = numbers.replace(/(\d{2})(\d)/, '($1) $2');
			numbers = numbers.replace(/(\d{4})(\d)/, '$1-$2');
		}else{
			numbers = numbers.replace(/(\d{2})(\d)/, '($1) $2');
			numbers = numbers.replace(/(\d{5})(\d)/, '$1-$2');
		}

		event.target.value = numbers;
	});

	modalWrapper.addEventListener('click', event => {
		if(event.target.dataset.leadClose){
			closeModal('dismissed');
		}
	});

	document.addEventListener('keydown', event => {
		if(event.key === 'Escape' && modalWrapper.classList.contains('is-visible')){
			closeModal('dismissed');
		}
	});

	form.addEventListener('submit', async event => {
		event.preventDefault();

		var formData = {
			nome: form.nome.value.trim(),
			email: form.email.value.trim(),
			telefone: form.telefone.value.trim(),
			politica: form.politica.checked
		};

		if(!formData.nome || !formData.email || !formData.telefone || formData.politica !== true){
			feedback.textContent = 'Preencha os campos e aceite a pol\u00edtica para continuar.';
			feedback.classList.add('is-visible');
			return false;
		}

		submitButton.disabled = true;
		submitButton.textContent = 'Enviando...';
		feedback.textContent = 'Enviando seus dados...';
		feedback.classList.add('is-visible');

		var mensagemLead = `Lead captado no popup de entrada. P\u00e1gina: ${window.location.href}`;

		try{
			var response = await ajaxAsync('/contato/enviarpopup', {
				xhr: 'xhr',
				nome: formData.nome,
				email: formData.email,
				telefone: formData.telefone,
				mensagem: mensagemLead
			});

			if(!response || response.r !== 'ok'){
				var errorMessage = response && response.info ? response.info : 'Nao foi possivel enviar agora.';
				var error = new Error(errorMessage);
				error.response = response;
				throw error;
			}

			if(window.localStorage){
				localStorage.setItem(storageLeadKey, JSON.stringify(formData));
			}

			feedback.textContent = response.info ? response.info : 'Recebemos seus dados com sucesso!';
			feedback.classList.add('is-visible');

			window.setTimeout(() => {
				closeModal('submitted');
			}, 1200);
		}catch(error){
			console.error(error);
			submitButton.disabled = false;
			submitButton.textContent = 'Quero atendimento';
			feedback.textContent = error && error.message ? error.message : 'N\u00e3o foi poss\u00edvel enviar agora. Tente novamente em alguns instantes.';
			feedback.classList.add('is-visible');
		}
	});

	document.body.appendChild(modalWrapper);

	window.setTimeout(() => {
		openModal();
	}, 800);
};

window.addEventListener('load', window.initLeadEntranceModal);
